<template>
  <div>
    <Modal
      v-model="waitModal"
      width="460"
      class="loading-modal"
      footer-hide
      :closable="false"
      :mask-closable="false"
    >
      <div class="demo-spin-container">
        <div>加载中...</div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  data () {
    return {
      // 等待弹框显示和隐藏
      waitModal: false,
      waitContent: ''
    }
  },
  methods: {
    // 显示弹框
    show () {
      this.waitModal = true
    },
    // 隐藏弹框
    hide () {
      this.waitModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
/* 等待模态框样式 */
.loading-modal {
  .demo-spin-container {
    display: inline-block;
    width: 100%;
    height: 100px;
    position: relative;
    div {
      text-align: center;
      color: #2d8cf0;
      font-size: 18px;
    }
  }

  @keyframes ani-demo-spin {
    from {
      transform: rotate(0deg);
    }

    50% {
      transform: rotate(180deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading/index.vue